import type { ComponentType } from 'react';

export type RouteId = 'roster' | 'band' | 'releases' | 'release' | 'merch' | 'dossiers' | 'contact' | 'login';

export const routeLoaders: Record<RouteId, () => Promise<ComponentType>> = {
  roster: () => import('@/app/pages/Roster').then((mod) => mod.Roster),
  band: () => import('@/app/pages/BandDossier').then((mod) => mod.BandDossier),
  releases: () => import('@/app/pages/Releases').then((mod) => mod.Releases),
  release: () => import('@/app/pages/ReleaseDetail').then((mod) => mod.ReleaseDetail),
  merch: () => import('@/app/pages/Merch').then((mod) => mod.Merch),
  dossiers: () => import('@/app/pages/Dossiers').then((mod) => mod.Dossiers),
  contact: () => import('@/app/pages/Contact').then((mod) => mod.Contact),
  login: () => import('@/app/pages/Login').then((mod) => mod.Login),
};

export const loadedRoutes = new Map<RouteId, ComponentType>();

function normalizePath(pathname: string) {
  const base = import.meta.env.BASE_URL.replace(/\/$/, '');
  let path = pathname.split('?')[0].split('#')[0];
  if (base && path.startsWith(base)) path = path.slice(base.length) || '/';
  if (path.length > 1 && path.endsWith('/')) path = path.slice(0, -1);
  return path || '/';
}

export function routeIdFor(pathname: string): RouteId | null {
  const path = normalizePath(pathname);
  if (path === '/roster') return 'roster';
  if (path.startsWith('/roster/')) return 'band';
  if (path === '/releases') return 'releases';
  if (path.startsWith('/releases/')) return 'release';
  if (path === '/merch') return 'merch';
  if (path === '/dossiers') return 'dossiers';
  if (path === '/contact') return 'contact';
  if (path === '/login') return 'login';
  return null;
}

export async function preloadRoute(pathname: string) {
  const id = routeIdFor(pathname);
  if (!id || loadedRoutes.has(id)) return;
  loadedRoutes.set(id, await routeLoaders[id]());
}
